// import Seo from "@/components/Seo/Seo";
import Wrapper from "../../layout/wrapper/Wrapper";
import { Box, Tab, TableCell, Tabs } from "@mui/material";
import styles from "../../styles/pages/published.module.scss";
import styles1 from "../../styles/pages/home.module.scss";
import React, { useState, useEffect } from "react";
import PublishedGraph from "../../components/PublishedGraph/PublishedGraph";
import PublishedFile from "../../components/PublishedFile/PublishedFile";
import ClearedPublishTable from "../../components/AllTable/ClearedVideoPageTables/ClearedPublishTable";
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";
import {
  setManagerId,
  setPurchased,
  setUserId,
  setMonth,
  setYear,
  setSubmitPlace,
  setHasNote,
  setUnreachableSubmitter,
  setHasMessage,
  setPeopleAppearing,
  setPersonWhoFilmed,
  setSubmitOtherWebsite,
  setAgreementWithAnotherCompany,
  setFrom,
  setTo,
  setPublished,
  setApiActiveTwo,
  setCheck,
} from "../../redux-toolkit/slices/cleared.published.slice";
import EmptyTable from "../../components/EmptyTable/EmptyTable";
import { Filter } from "@mui/icons-material";
import { useAppSelector } from "../../hooks/useAppSelector";
import { useAppDispatch } from "../../hooks/useAppDispatch";
import { useQuery } from "react-query";
import { FetchSubmitedVideos } from "../../api/functions/submited.videos.api";
import ApiLoader from "../../components/Loaders/ApiLoader";
import axiosInstance from "../../api/axiosInstance";
import { getStartEndDateTwo, years } from "../../lib/functions/utils.lib";
import assest from "../../json/assest";
import { red } from "@mui/material/colors";
import { color } from "@mui/system";

function PublishedPage() {
  const [page, setPage] = useState(1);
  // console.warn("page", page);
  const [openFilterModal, setOpenFilterModal] = useState(false);
  const dispatch = useAppDispatch();

  const [fetchTrigger, setFetchTrigger] = useState(Date.now());

  const [getmounth, setGetmouth] = useState("");

  const years = [];
  const currentYear = new Date().getFullYear();
  const [getyear, setGetYear] = useState(currentYear);

  for (let year = currentYear; year >= 2021; year--) {
    years.push(year);
  }

  function getStartAndEndDate(monthName, year) {
    // Create a mapping of month names to their numeric values
    const monthMap = {
      January: 0,
      February: 1,
      March: 2,
      April: 3,
      May: 4,
      June: 5,
      July: 6,
      August: 7,
      September: 8,
      October: 9,
      November: 10,
      December: 11,
    };

    // Get the numeric value of the month from the month name
    const monthValue = monthMap[monthName];

    if (typeof monthValue !== "undefined" && !isNaN(year)) {
      // Create a Date object for the first day of the specified month and year
      const startDate = new Date(year, monthValue, 1);

      // Calculate the last day of the specified month and year
      const endDate = new Date(year, monthValue + 1, 0);

      // Format the dates as strings in the 'YYYY-MM-DD' format=

      const startDateStr = `${startDate.getFullYear()}-${String(
        startDate.getMonth() + 1
      ).padStart(2, "0")}-${String(startDate.getDate()).padStart(2, "0")}`;
      const endDateStr = `${endDate.getFullYear()}-${String(
        endDate.getMonth() + 1
      ).padStart(2, "0")}-${String(endDate.getDate()).padStart(2, "0")}`;

      return {
        start_date: startDateStr,
        end_date: endDateStr,
      };
    } else {
      return null; // Invalid input
    }
  }

  const result = getStartAndEndDate(getmounth, getyear);
  console.warn("result1", result);

  const {
    manager_id,
    published,
    purchased,
    user_id,
    month,
    year,
    submit_place,
    has_note,
    unreachable_submitter,
    hasMessage,
    people_appearing,
    person_who_filmed,
    submit_other_website,
    aggrement_with_another_company,
    from,
    to,
    confirmed,
    apiActiveTwo,
    check,
  } = useAppSelector((s) => s.publishedCleareddSlice);
  console.warn("result1", month, year);
  console.warn("result1", from, to, check);

  const {
    error,
    data,
    isLoading,
    isRefetching,
    refetch: refetchAgain,
  } = useQuery(
    ["publish1"],
    async () =>
      FetchSubmitedVideos({
        // status: 1,
        // manager_decision : 1,
        // awaiting_confirmation : "yes",
        page,
        manager_id,
        published: 1,
        purchased,
        user_id,
        submit_place: submit_other_website,
        has_note,
        unreachable_submitter,
        hasMessage,
        people_appearing,
        person_who_filmed,
        country: submit_place,

        aggrement_with_another_company,
        from:
          month || year
            ? getStartEndDateTwo(month, year).start_date
            : from && check
            ? from
            : result.start_date,
        to:
          month || year
            ? getStartEndDateTwo(month, year).end_date
            : to && check
            ? to
            : result.end_date,
      })
    /* {
      enabled: confirmed,
    } */
  );

  // const {
  //   error: error2,
  //   data: data2,
  //   isLoading: isLoading2,
  //   isRefetching: isRefetching2,
  //   refetch: refetchAgain2,
  // } = useQuery(
  //   ["publish2"],
  //   async () =>
  //     FetchSubmitedVideos({
  //       // status: 1,
  //       manager_decision: 1,
  //       published: "yes",
  //       page,
  //       manager_id,
  //       published: 1,
  //       purchased,
  //       user_id,
  //       month,
  //       year,
  //       submit_place: submit_other_website,
  //       has_note,
  //       unreachable_submitter,
  //       hasMessage,
  //       people_appearing,
  //       person_who_filmed,
  //       country: submit_place,
  //       aggrement_with_another_company,
  //       from,
  //       to,
  //     }),
  //   {
  //     enabled: apiActiveTwo && data ? true : false,
  //     onSuccess: (d2) => {
  //       // console.warn("d2", d2?.data?.data);
  //       if (d2?.data?.data?.length < 1) {
  //         setApiActiveTwo(false);
  //       }
  //     },
  //   }
  // );

  const handlePageChange = (p) => {
    setPage(p);
    handleTriggreFetch();
  };

  useEffect(() => {
    refetchAgain();
  }, [fetchTrigger]);

  const filterRefetch = () => {
    refetchAgain();
    setOpenFilterModal(false);
  };

  const filtersReset = () => {
    dispatch(setCheck(false));
    dispatch(setFrom(null));
    dispatch(setTo(null));
    dispatch(setHasNote(null));
    dispatch(setSubmitPlace(null));
    dispatch(setUserId(null));
    dispatch(setMonth(null));
    dispatch(setYear(null));
    dispatch(setYear(null));
    dispatch(setUnreachableSubmitter(null));
    dispatch(setPeopleAppearing(null));
    dispatch(setPersonWhoFilmed(null));
    dispatch(setSubmitOtherWebsite(null));
    dispatch(setAgreementWithAnotherCompany(null));
    dispatch(setManagerId(null));
    dispatch(setManagerId(null));
    dispatch(setPurchased(null));
    dispatch(setHasMessage(null));
    dispatch(setPublished(null));
    setPage(1);
    handleTriggreFetch();
  };

  const handleTriggreFetch = () => {
    setFetchTrigger(Date.now());
  };

  const handleClearFilterModal = () => {
    dispatch(setCheck(false));
    dispatch(setHasNote(null));
    dispatch(setSubmitPlace(null));
    dispatch(setUserId(null));
    dispatch(setMonth(null));
    dispatch(setYear(null));
    dispatch(setUnreachableSubmitter(null));
    dispatch(setPeopleAppearing(null));
    dispatch(setPersonWhoFilmed(null));
    dispatch(setSubmitOtherWebsite(null));
    dispatch(setAgreementWithAnotherCompany(null));
    dispatch(setManagerId(null));
    dispatch(setManagerId(null));
    dispatch(setPurchased(null));
    dispatch(setHasMessage(null));
    dispatch(setPublished(null));
    setOpenFilterModal(false);
    setPage(1);
    handleTriggreFetch();
  };
  const [fileData, setFileData] = useState([]);

  let total = 0;

  for (let i = 0; i < fileData.length; i++) {
    total += fileData[i].total;
  }

  const yearOpts = years.map((year) => {
    return <option value={year}>{year}</option>;
  });

  const [value, setValue] = React.useState(new Date().getFullYear());
  // const Chart = dynamic(() => import("react-apexcharts"), { ssr: false });
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  console.warn(value, "615316725367");

  const bargraphApi = async () => {
    await axiosInstance
      .get(`/admin/graph/videos/${value}`)
      .then((res) => {
        setFileData(res?.data?.data);
        console.warn(res.data, "res-------");
      })
      .catch((e) => {
        setValue;
        console.warn(e);
      });
  };
  useEffect(() => {
    bargraphApi();
  }, [value]);
  const [clickedValue, setClickedValue] = useState("");
  const handleClick = (value) => {
    setGetmouth(value);
  };

  useEffect(() => {
    if (getmounth !== "") {
      refetchAgain(); // Call the API when getmounth is not empty
    }
  }, [getmounth]);

  return (
    <Wrapper>
      <ApiLoader loading={isLoading || isRefetching} />
      {/* <Seo
                title="Published"
                canonical={""}
                description={""}
                url={""}
                image={""}
            /> */}
      <Box className="main_body">
        <Box
          className={`${styles.publishedFullScroll} ${styles.publishedFullMnScl}`}
        >
          {/* <PerfectScrollbar> */}
          {data === undefined ? (
            <>
              <Box className={styles.publishedTabWrapper}>
                <Box className={styles.publishedTab}>
                  <Tabs
                    value={value}
                    aria-label="basic tabs example"
                    onChange={handleChange}
                  >
                    {/* <Tab label="2023" value={2023} />
                       <Tab label="2022" value={2022} />
                       <Tab label="2021" value={2021} /> */}

                    {yearOpts.map((i) => {
                      return (
                        <Tab
                          label={i.props.value}
                          value={i.props.value}
                          onClick={() => setGetYear(i.props.value)}
                        />
                      );
                    })}
                  </Tabs>
                </Box>
                {total !== 0 ? <PublishedGraph data={fileData} /> : ""}
              </Box>
              {total !== 0 ? (
                <Box className={styles.fileUploadMain}>
                  <PerfectScrollbar className={styles.publishedScrollBar}>
                    <Box className={styles.fileUploadWrapper}>
                      {fileData?.map((item, index) => {
                        // styles={{  color: item.total === 0 ? red : '#e8f5e9'   }}
                        return (
                          <Box
                            className={styles.fileItemBox}
                            onClick={() => handleClick(item.month)}
                          >
                            <Box
                              className={
                                item.total === 0
                                  ? `${styles.fileUploadItem} ${styles.noDatafileUploadItem}`
                                  : styles.fileUploadItem
                              }
                              key={index}
                            >
                              <Box className={styles.fileIcon}>
                                <img
                                  src={assest.fileIcon}
                                  width={41}
                                  height={32}
                                  alt=""
                                />
                              </Box>
                              <Box className={styles.fileicons_btms}>
                                <h5>
                                  {item.total} <span>{"Videos"}</span>
                                </h5>
                                <p>
                                  {item.month} <span>{getyear}</span>
                                </p>
                              </Box>
                            </Box>
                          </Box>
                        );
                      })}
                    </Box>
                  </PerfectScrollbar>
                </Box>
              ) : (
                <Box className={`${styles1.borderNone} ${styles.noDataFile}`}>
                  <PerfectScrollbar className={styles.publishedScrollBarEmpty}>
                    <EmptyTable
                      emptyTableText={
                        // "You have no approved videos at the moment. Please reload the page or check back later."
                        `  No videos have been published in ${getyear}. Please check back later or refresh the page.`
                      }
                    />
                  </PerfectScrollbar>
                </Box>
              )}
            </>
          ) : (
            <>
              <ClearedPublishTable
                datas={data?.data}
                handlePageChange={handlePageChange}
                filterRefetch={filterRefetch}
                handleClearFilterModal={handleClearFilterModal}
                filtersReset={filtersReset}
                setPage={setPage}
                page={page}
                confirmed={confirmed}
                getmounth={getmounth}
                getyear={getyear}
                p={{
                  openFilterModal,
                  setOpenFilterModal,
                  handleTriggreFetch,
                  filtersReset,
                  filterRefetch,
                }}
              />
            </>
          )}
        </Box>
      </Box>
    </Wrapper>
  );
}

export default PublishedPage;
